import { EventEmitter, Component, Output, Input } from '@angular/core';
import { IStockFileEntry, IStockFolder } from 'src/app/tools/api.service';
import {FileDeleteModalResult } from '../cloud/cloud.component';


@Component({
    selector: 'cloud-delete-modal',
    templateUrl: './delete-modal.component.html',
    styleUrls: ['./delete-modal.component.scss']
})

export class CloudDeleteModalComponent {
    @Input() fileId: number;
    @Input() folder: IStockFolder;
    @Input() deleteProgress: boolean;
    @Input() isComm: boolean;
    @Output() close = new EventEmitter<void>();
    @Output() delete = new EventEmitter<FileDeleteModalResult>();
    @Output() reset = new EventEmitter<void>();

    formsDisabled: boolean = false;
    formsShowGlobalError: boolean = false;

    constructor() { }

    doClose() {
        this.close.emit();
    }

    async doDelete() {
        this.formsShowGlobalError = false;
        this.reset.emit();

        this.delete.emit({
            id: this.fileId,
            folder: this.folder,
            formStatusChanger: (state: boolean) => this.changeFormState(state)
        });
    }

    changeFormState(state: boolean) {
        if (!state)
            this.formsShowGlobalError = true;

        this.formsDisabled = state;
    }
}
